import { type FC, type PropsWithChildren, useMemo, useState } from 'react';

import { HoveredOfferActionsContextProvider, HoveredOfferContextProvider } from '../../context/HoveredOfferContext';

export const HoveredOfferProvider: FC<PropsWithChildren> = ({ children }) => {
  const [offerGeoHash, setOfferGeoHash] = useState<string>();

  const hoveredOfferActionsContext = useMemo(
    () => ({
      onOfferHover: (geoHash: string): void => {
        setOfferGeoHash(geoHash);
      },
      onOfferBlur: (): void => {
        setOfferGeoHash(undefined);
      },
    }),
    [],
  );

  const hoveredOfferContext = useMemo(() => ({ hoveredOfferGeoHash: offerGeoHash }), [offerGeoHash]);

  return (
    <HoveredOfferContextProvider value={hoveredOfferContext}>
      <HoveredOfferActionsContextProvider value={hoveredOfferActionsContext}>
        {children}
      </HoveredOfferActionsContextProvider>
    </HoveredOfferContextProvider>
  );
};
